import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_81: DocMigration = {
  maxSchemaVersion: "0.0.81",
  description: "Replace references to masonryTrim* palette slots that don't specify trim kind with masonryTrim*:Base",
  apply(json: any) {
    const renameRegexMasonryTrim = /^masonryTrim[0-2]$/;

    // We also clean up bugged values that say "exteriorTrim" when it should be "trimExterior".
    const renameRegexExteriorTrim = /^exteriorTrim[0-2]$/;
    const renameValue = (o: any, propertyName: string) => {
      if (!o.hasOwnProperty(propertyName)) {
        return;
      }

      if (o[propertyName].match(renameRegexMasonryTrim)) {
        o[propertyName] = o[propertyName] + ":Base";
      }
      if (o[propertyName].match(renameRegexExteriorTrim)) {
        const prevPaletteKey = o[propertyName];
        o[propertyName] = "trimExterior" + prevPaletteKey[prevPaletteKey.length - 1];
      }
    };

    if (json.facades) {
      for (const facadeId in json.facades) {
        const facade = json.facades[facadeId];

        if (facade.spanStrata) {
          for (const spanStratum of facade.spanStrata) {
            renameValue(spanStratum, "name");
            renameValue(spanStratum, "material");
          }
        }

        if (facade.sweepStrata) {
          for (const spawnStratum of facade.sweepStrata) {
            renameValue(spawnStratum, "name");
            renameValue(spawnStratum, "material");
          }
        }
      }
    }

    if (json.settings) {
      for (const settingKey in json.settings) {
        const setting = json.settings[settingKey];

        renameValue(setting, "material");
        renameValue(setting, "trimMaterial");
        renameValue(setting, "apronCasingMaterial");
        renameValue(setting, "sideCasingMaterial");
        renameValue(setting, "headCasingMaterial");
        renameValue(setting, "exteriorWallMaterial");
        renameValue(setting, "roofMaterial");

        if (setting.columnTable) {
          for (const columnKey in setting.columnTable) {
            const column = setting.columnTable[columnKey];
            for (const section of column.sections) {
              renameValue(section, "paletteId");
            }
          }
        }
        if (setting.headCasingSlices) {
          for (const slice of setting.headCasingSlices) {
            renameValue(slice, "material");
          }
        }
      }
    }

    if (json.roomLayouts) {
      for (const layoutKey of Object.keys(json.roomLayouts)) {
        const layout = json.roomLayouts[layoutKey];
        if (layout.openingPatterns) {
          for (const openingPattern of layout.openingPatterns) {
            if (openingPattern.openings) {
              for (const opening of openingPattern.openings) {
                if (opening.exteriorCasing) {
                  renameValue(opening.exteriorCasing, "material");
                  renameValue(opening.exteriorCasing, "apronCasingMaterial");
                  renameValue(opening.exteriorCasing, "sideCasingMaterial");
                  renameValue(opening.exteriorCasing, "headCasingMaterial");
                  if (opening.exteriorCasing.headCasingSlices) {
                    for (const slice of opening.exteriorCasing.headCasingSlices) {
                      renameValue(slice, "material");
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    return json;
  },
};

export default migration_0_0_81;
